'use client';
import Link from 'next/link';
import { Frown } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <main className="flex min-h-[calc(100vh-50px)] flex-col items-center justify-center gap-2">
      <Frown size={40} className="w-10 text-gray-400" />
      <h2 className="text-xl font-semibold">404</h2>
      <p>页面不存在</p>
      <Button variant="outline" asChild>
        <Link href="/">返回首页</Link>
      </Button>
    </main>
  );
}
